import {
  Component, Inject, OnDestroy, OnInit,
} from '@angular/core';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

@Component({
  selector: 'ut-unified-registration-layout',
  templateUrl: './layout.component.html',
  standalone: false,
})
export class UnifiedRegistrationLayoutComponent implements OnInit, OnDestroy {
  showLoginButton: boolean = true;
  currentYear: number = new Date().getFullYear();
  private recaptchaScriptLoaded = false;

  constructor(
    @Inject('UserService') private UserService: any,
    @Inject('forceHideLoginButton') private forceHideLoginButton: boolean,
    @Inject('ConfigService') private ConfigService: any,
  ) { }

  getLoginUrl(): string {
    if (this.getCurrentPathname().startsWith('/signup')) {
      return '/login';
    }
    const returnUrl = encodeURIComponent(this.getCurrentHref());
    return `/login?return_to=${returnUrl}`;
  }

  getCurrentPathname(): string {
    return window.location.pathname;
  }

  getCurrentHref(): string {
    return window.location.href;
  }

  ngOnInit(): void {
    if (this.forceHideLoginButton === true) {
      this.showLoginButton = false;
    } else {
      this.UserService.me().then((result: any) => {
        this.showLoginButton = result === null;
      });
    }

    document.body.classList.add('overflow-auto');

    this.loadRecaptchaScript();
  }

  ngOnDestroy(): void {
    document.body.classList.remove('overflow-auto');
    this.removeRecaptchaScript();
  }

  private loadRecaptchaScript(): void {
    if (this.recaptchaScriptLoaded) {
      return;
    }

    this.ConfigService.config().then((response: any) => {
      const siteKey = response.data.recaptcha_v3_site_key;
      if (!siteKey) {
        console.warn('reCAPTCHA v3 Enterprise site key not found in config');
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      script.id = 'recaptcha-script';
      document.head.appendChild(script);
      this.recaptchaScriptLoaded = true;
    }).catch((error: any) => {
      console.error('Failed to load reCAPTCHA config:', error);
    });
  }

  private removeRecaptchaScript(): void {
    // Remove reCAPTCHA script element
    const script = document.getElementById('recaptcha-script');
    if (script) {
      script.remove();
    }

    // Clean up any reCAPTCHA elements that may have been created
    const recaptchaElements = document.querySelectorAll('[id^="recaptcha"], .grecaptcha-badge');
    recaptchaElements.forEach((element) => element.remove());

    // Clear reCAPTCHA from window object
    if (window.grecaptcha) {
      delete window.grecaptcha;
    }

    this.recaptchaScriptLoaded = false;
  }
}

export default UnifiedRegistrationLayoutComponent;
